const AUTH_URL = process.env.VUE_APP_AUTH_BASE_URL
const BASE_URL = process.env.VUE_APP_BASE_URL

export default {

  getAuthUrl () {
      return AUTH_URL;
  },

  getServerHost(){
      return BASE_URL;
  },

  getLoginLink(){
      return `${this.getAuthUrl()}/login/?redirect_url=${this.getServerHost()}/validation`;
  }
}
